import { SET_HAS_CHANGES } from "common/actions/common";
import { store } from "common/store";

export const unsavedChangesHook = function() {
    if (store.getState().common.has_unsaved_changes) {
        const result = window.confirm("You have unsaved changes on this page. Are you sure you want to leave?");
        if (result) {
            // Set flag back to false since the user wants to ignore changes
            store.dispatch(SET_HAS_CHANGES(false));
        }
        return result;
    }
    
    return true;
};
